import React, { useState, useEffect } from "react";
import {
  Warning,
  CheckboxSelector,
  Button
} from "@onegovbugs/onegov-react-components";
import styles from "./declaration.module.scss";
import { saveApplication } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { isSelected, validate } from "../../utils/Validation";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";
import { TATTOO_OPERATOR_FORM } from "../../constants";

const Declaration = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();

  const [agreeDeclaration, setAgreeDeclaration] = useState([]);
  const form = useSelector(state => state.form);

  const defaultCheckboxValue = {
    value: 1,
    label: "I agree to all of the above"
  };

  const checkboxValues = [defaultCheckboxValue];
  const formType = useState(() => {if (form.form === TATTOO_OPERATOR_FORM){
    return 'Master';
  }
  else{
    return 'tattooist';
  }
  }); 

  return (
    <div className={styles.mainCont}>
      <div className={styles.borderBox}>
        <div className={"row"}>
          <div className={"col-12"}>
            <div className={styles.content}>
              <h2>
                Make the following declaration and consent by clicking the “I agree” button
                below.
              </h2>
              <p>
              I apply for the grant of a {formType} licence under the <i>Tattoo Industry Act 2012</i> and:
              </p>
              
              <ul>
                <li>
                	certify that the information contained in this application is true and correct in every detail;
                </li>
                <li>
                  understand that giving false or misleading information is a serious offence;
                </li>
                <li>
                  consent to the disclosure by the relevant authority of information needed to 
                  verify any details I have given in this application;
                </li>
                <li>
                  consent to having my fingerprints and palmprints taken by a police officer in 
                  NSW in order to confirm my identity;
                </li>
                <li>
                  consent to and do request Australian police agencies to release, to the NSW Police Force, 
                  information held by any of them regarding any convictions, findings of guilt (either with 
                  or without conviction) and any matters still outstanding against me and any other matters 
                  deemed relevant that are recorded against me, whether in my current name or a previous name;
                </li>
                <li>
                	authorise disclosure to the NSW Police Force by New Zealand Police of ANY information that 
                  may be held by NZ Police, including any interaction I have had with NZ Police in any context 
                  or any information received by NZ Police. I understand that this is not limited to conviction 
                  information. Where that information relates to any record of criminal convictions I might have, 
                  I understand that it will automatically be concealed if I meet the eligibility criteria stipulated 
                  in section 7 of the NZ Criminal Records (Clean Slate) Act 2004; and
                </li>
                <li>
                	have attached all documents where requested by this application.
                </li>
              </ul>
              <p>
                I acknowledge and agree:
              </p>
              <ul className={styles.lstStyle}>  
                <li>
                	that the NSW Police Force relies on other State and Commonwealth jurisdictions (Other Agencies) 
                  to provide information to it (Other Agency Information);
                </li>
                <li>
                	to release the NSW Police Force from any liability arising from any errors or omissions contained in 
                  that Other Agency Information; and
                </li>
                <li>
                	to release and indemnify those Other Agencies from any actions and demands that I may have available 
                against them arising out of the release by them to the NSW Police Force of Other Agency Information.
                </li>                
              </ul>
              <p>
                The above acknowledgment does not alter any rights I may have under legislation.
              </p>
            </div>
            <Warning type={"warning"}>
              <p>
                <strong>
                  Note: It is an offence under the <i>Crimes Act 1900</i> to make a
                  false or misleading statement in this application.
                </strong>
              </p>
            </Warning>
            <div className={styles.agreeCheckbox}>
              <CheckboxSelector
                onSelectionChange={v => {
                  setAgreeDeclaration(v);
                }}
                initialValue={agreeDeclaration}
                options={checkboxValues}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`row ` + styles.topMargin128}>
        <div className={`col-12`}>
          <Button
            disabled={agreeDeclaration != 1}
            onClick={() => {
              form.form === 'operator' ? props.history.push(`/operator/fee-breakdown`) : props.history.push(`./fee-breakdown`);
            }}
          >
            Continue
          </Button>
          <Button
            secondary
            onClick={() => {
              dispatch(
                saveApplication("step8", () => {
                  {
                    form.form === TATTOO_OPERATOR_FORM ?
                      props.history.push(`/operator/dashboard`) :
                      window.location.href = `${process.env.REACT_APP_BAU_URL}`
                  }
                })
              );
            }}
          >
            Save & exit section
        </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(props => <Declaration {...props} />);
